import { ToastClassName } from "react-toastify";
import { styles } from "./generate-toast-className.styles";

export const generateClassName: ToastClassName = (props) =>
  `${props?.defaultClassName} px-4 py-3 h-min min-h-fit min-w-min gap-12 ${
    props?.type ? styles?.[props.type] : ""
  }`;
